import { render, staticRenderFns } from "./cardCalls.vue?vue&type=template&id=c04a2338&"
import script from "./cardCalls.vue?vue&type=script&lang=js&"
export * from "./cardCalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports